var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0041E",
    d: "M1 17l8-7 16 1 1 16-7 8s.001-5.999-6-12-12-6-12-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M.973 35s-.036-7.979 2.985-11S15 21.187 15 21.187 14.999 29 11.999 32c-3 3-11.026 3-11.026 3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 8.999,
    cy: 27,
    r: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M35.999 0s-10 0-22 10c-6 5-6 14-4 16s11 2 16-4c10-12 10-22 10-22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.999 5c-1.623 0-3.013.971-3.641 2.36.502-.227 1.055-.36 1.641-.36 2.209 0 4 1.791 4 4 0 .586-.133 1.139-.359 1.64 1.389-.627 2.359-2.017 2.359-3.64 0-2.209-1.791-4-4-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0041E",
    d: "M8 28s0-4 1-5 13.001-10.999 14-10-9.001 13-10.001 14S8 28 8 28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic2);
export default __webpack_public_path__ + "static/media/pic2.0e0879f59b4d417e93247c8d912da1f9.svg";
export { ForwardRef as ReactComponent };